import { ClassLevel } from "@prisma/client";

// Level display mapping — values are `classes` catalog keys, resolved by callers
const CLASS_LEVEL_LABELS: Record<ClassLevel, string> = {
    BEGINNER: "levelBeginner",
    INTERMEDIATE: "levelIntermediate",
    ADVANCED: "levelAdvanced",
    CUSTOM: "levelCustom",
};

// Level options for forms
export const CLASS_LEVEL_OPTIONS = [
    {
        value: "BEGINNER",
        labelKey: "levelBeginner",
        id: "BEGINNER",
    },
    {
        value: "INTERMEDIATE",
        labelKey: "levelIntermediate",
        id: "INTERMEDIATE",
    },
    {
        value: "ADVANCED",
        labelKey: "levelAdvanced",
        id: "ADVANCED",
    },
    {
        value: "CUSTOM",
        labelKey: "levelCustom",
        id: "CUSTOM",
    },
];

/**
 * Get the `classes` message key for a class level; pass it through t().
 */
export function getClassLevelLabelKey(level: ClassLevel): string {
    return CLASS_LEVEL_LABELS[level];
}
